import React, { useState } from 'react';
import SendGridCredentialsCard from '../sendgrid/SendGridCredentialsCard';
import TextableCredentialsCard from '../textable/TextableCredentialsCard';
import DeluxeCredentialsCard from '../deluxe/DeluxeCredentialsCard';
import './PlatformCredentialsTabs.css';

const TABS = [
  { id: 'sendgrid', label: 'SendGrid', hint: 'Email' },
  { id: 'textable', label: 'Textable', hint: 'SMS' },
  { id: 'deluxe', label: 'Deluxe', hint: 'Payments' },
];

const PlatformCredentialsTabs = () => {
  const [activeTab, setActiveTab] = useState('deluxe');

  return (
    <section className="admin-card app-settings-card platform-credentials-tabs">
      <div className="platform-credentials-tabs__intro">
        <h2 className="platform-credentials-tabs__title">Platform credentials</h2>
        <p className="platform-credentials-tabs__desc">
          Email, SMS, and payment keys for Neat Schedule. Company booking keys stay on each company.
        </p>
      </div>

      <div className="platform-credentials-tabs__list" role="tablist" aria-label="Platform credentials">
        {TABS.map((tab) => {
          const selected = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              type="button"
              role="tab"
              id={`platform-credentials-tab-${tab.id}`}
              aria-selected={selected}
              aria-controls={`platform-credentials-panel-${tab.id}`}
              tabIndex={selected ? 0 : -1}
              className={`platform-credentials-tabs__tab${selected ? ' is-active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <span className="platform-credentials-tabs__tab-label">{tab.label}</span>
              <span className="platform-credentials-tabs__tab-hint">{tab.hint}</span>
            </button>
          );
        })}
      </div>

      <div
        className="platform-credentials-tabs__panel"
        role="tabpanel"
        id={`platform-credentials-panel-${activeTab}`}
        aria-labelledby={`platform-credentials-tab-${activeTab}`}
      >
        <div hidden={activeTab !== 'sendgrid'}>
          <SendGridCredentialsCard />
        </div>
        <div hidden={activeTab !== 'textable'}>
          <TextableCredentialsCard />
        </div>
        <div hidden={activeTab !== 'deluxe'}>
          <DeluxeCredentialsCard />
        </div>
      </div>
    </section>
  );
};

export default PlatformCredentialsTabs;
